const ReportFiltersCard = ({
    title,
    description,
    children,
    actions,
    fieldsClassName = "grid grid-cols-1 gap-4 xl:grid-cols-4",
}) => {
    return (
        <div className="p-5 mt-6 bg-white border shadow-sm rounded-xl border-slate-200">
            {(title || description) && (
                <div className="mb-4">
                    {title && (
                        <h2 className="text-base font-semibold text-slate-800">
                            {title}
                        </h2>
                    )}
                    {description && (
                        <p className="mt-1 text-sm text-slate-500">
                            {description}
                        </p>
                    )}
                </div>
            )}

            <div className={fieldsClassName}>{children}</div>

            {actions && <div className="flex justify-end mt-5">{actions}</div>}
        </div>
    );
};

export const ReportFilterField = ({ label, children, className = "" }) => (
    <div className={className}>
        <label className="block mb-2 text-sm font-semibold text-slate-700">
            {label}
        </label>
        {children}
    </div>
);

export default ReportFiltersCard;
